import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Menu, Button, SvgIcon, MenuItem, Typography } from '@mui/material';

import { LANGUAGES } from '@/features/shared/constants';
import { WorldIcon } from '@/utils/iconSVG';

import { stylesButtonMenuText } from './LanguageSwitcher.styles';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation('layouts');

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openMenu = Boolean(anchorEl);

  const handleClickListItem = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuItemClick = (event: MouseEvent<HTMLElement>) => {
    const { textContent: selectedLanguage } = event.currentTarget as unknown as MouseEvent<HTMLElement> & {
      textContent: string;
    };
    i18n.changeLanguage(selectedLanguage.toLowerCase());
    localStorage.setItem('sherpass-language', selectedLanguage.toLowerCase());
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button color='black' onClick={handleClickListItem} arial-label='Changer de langue'>
        <Typography component='span' sx={stylesButtonMenuText}>
          {i18n.language.toUpperCase()}
        </Typography>
        <SvgIcon component={WorldIcon} />
      </Button>

      <Menu
        id='lock-menu'
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
      >
        {Object.values(LANGUAGES).map((option) => (
          <MenuItem key={option} selected={option === i18n.language} onClick={handleMenuItemClick}>
            {option.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
